import { filterQueryLevel } from '../../domain/entities/FilterQuery';

export interface IFilters {
    [filterCategory: string]: string[];
}

export interface IFilterCheckbox {
    label: string;
    key: string;
    id: string;
}

export interface IFilterMapItem {
    key_type: string;
    key_name: string;
    fe_map?: string;
}

export interface IFilterQuery {
    level: filterQueryLevel;
    map: IFilterMapItem[];
}

export interface IFilter {
    logic: FilterQueryLogic;
    label: string;
    items: IFilterCheckbox[];
    key: string;
    type: string;
    query: IFilterQuery[];
}

export enum FilterQueryLogic {
    AND = 'AND',
    OR = 'OR'
}

export interface ITranslation {
    horizontalFiltersTitle: string;
    seeProductsLabel: string;
    productsItemLabel: string;
    clearFiltersLabel: string;
}

export interface IGeneralKeys {
    key: string;
    label: string;
    minValue: string;
    maxValue: string;
}

export interface IFilterSets {
    items: IGeneralKeys[];
    label: string;
    key: string;
    logic: FilterQueryLogic;
    level: string;
    type: string;
    query: IFilterQuery[];
    isRange: boolean;
}

export interface IFilterData {
    filtersTitle: string;
    generalKeys: IGeneralKeys[];
    filterSets: IFilterSets[];
}
